export default __webpack_public_path__ + "static/image-3-265152274fedee74bbffb2c8aa8a2302.jpg";